<div class="overflow-auto" style="max-height: 80vh">
  @if (showEstimateWarningBanner$ | async) {
    <aux-warning-vendor-estimate
      class="block max-w-[720px]"
      (linkClick)="onLinkClick()"
      [vendor]="selectedVendor.value ?? ''"
      [month]="selectedMonth.value ?? ''"
    />
  }

  <div class="mt-4 grid w-[720px]">
    <div class="flex flex-col justify-between">
      @if (errorMessage()) {
        <div class="mb-4 rounded-md bg-aux-error p-5 font-medium text-white">
          {{ errorMessage() }}
        </div>
      }

      <div class="mx-0.5 grid grid-cols-2 gap-5">
        <div class="flex flex-col justify-between space-y-2">
          <div>
            <div class="mb-2 text-xs">
              <span class="font-bold text-aux-error">*</span>
              Vendor Contract
            </div>
            <ng-select
              class="select"
              placeholder="Select"
              label="Vendor Contract"
              id="vendor"
              [formControl]="selectedVendor"
              [appendTo]="'body'"
              [searchable]="true"
              [clearable]="false"
              auxFormError
              required
            >
              @for (vendor of vendorsQuery.allReceivesEstimateVendors$ | async; track vendor) {
                <ng-option [value]="vendor.id">
                  <span [title]="vendor.name">{{ vendor.name }}</span>
                </ng-option>
              }
            </ng-select>
          </div>
          <div class="mb-4">
            <div class="mb-2 text-xs">
              <span class="font-bold text-aux-error">*</span>
              Month
            </div>
            <ng-select
              placeholder="Select"
              id="months"
              [formControl]="selectedMonth"
              [appendTo]="'body'"
              [searchable]="true"
              [clearable]="false"
            >
              @for (month of availableMonths$; track month) {
                <ng-option [value]="month.date">
                  <span [title]="month.name">{{ month.name }}</span>
                </ng-option>
              }
            </ng-select>
          </div>
          <aux-input label="Short Name" [formControl]="shortName" />
          <aux-input label="Notes/Comments/Context" [formControl]="notes" />
          <aux-input label="Total Estimate Amount" placeholder="$" [formControl]="totalAmount" />
        </div>
        <div>
          <aux-file-manager
            #manager
            class="h-32"
            [fetchFilesOnInit]="false"
            [pathFn]="pathFn"
            [eager]="false"
            [metadata]="metadata"
            [showSuccessOnUpload]="true"
          />
          <div class="mt-2 text-xs">Uploaded Files</div>
          @if (fileManager?.fileQuery?.selectAll() | async; as files) {
            @if (files.length) {
              @for (file of files; track file; let last = $last) {
                <ng-container class="border-b">
                  <div
                    class="flex items-center justify-between py-2"
                    [ngClass]="{ 'border-b': !last }"
                  >
                    <div class="items-start break-all text-xs">
                      {{ file.fileName }}
                    </div>

                    <button
                      class="btn h-6 w-6 rounded-full border-0 p-0 shadow-none"
                      type="button"
                      (click)="removeFile(file)"
                    >
                      <aux-icon name="Trash" class="text-aux-error" />
                    </button>
                  </div>
                </ng-container>
              }
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>
